type Props = React.HTMLProps<HTMLInputElement>

export default function FadedUnderlinedInput({ className, ...otherProps }: Props) {
  return <input
    className={`${className} outline-0 border-b-1 border-dpLightGray placeholder-gray-500`}
    {...otherProps}
  />;
}